<template>
  <BaseField :baseRule="buildRules" v-bind="$attrs" :label="label" :placeholder="placeholder" v-model="inputValue">
    <template v-slot:beforeInput><span class="margin-right-5">〒</span></template>
    <template v-slot:feedback="slotProps">
      <div class="invalid-feedback" v-show="slotProps.invalid">
        {{ slotProps.errors[0] }}
      </div>
    </template>
    <template v-slot:afterInput="slotProps">
      <button type="button" class="btn-sm" @click="fillAddress(slotProps.valid, slotProps.validate)">
        住所検索
      </button>
    </template>
  </BaseField>
</template>

<script>
import BaseField from '@/components/forms/BaseField.vue';
import { addressByPostalCode } from '@/utils/geocoder';

export default {
  data() {
    return {
      rules: ['jp_postal_code'],
    };
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '郵便番号',
    },
    placeholder: {
      type: String,
      default: 'ハイフンなし7桁',
    },
  },
  components: {
    BaseField,
  },
  computed: {
    buildRules() {
      return this.rules.join('|');
    },
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.resetPostalCodeValidate();
        this.$emit('input', val);
      },
    },
  },
  methods: {
    resetPostalCodeValidate() {
      return (this.rules = ['jp_postal_code']);
    },
    markPostalCodeInvalid() {
      this.rules.push('jp_postal_code_invalid');
    },
    fillAddress(valid, validate) {
      if (valid) {
        addressByPostalCode(this.value).then((data) => {
          if (data) {
            this.$logger.debug('Geocoder result: ', data);
            this.$emit('fillAddresses', data);
            this.resetPostalCodeValidate();
          } else {
            this.$logger.debug('Geocoder result: Postal Code invalid!');
            this.markPostalCodeInvalid();
          }
        });
      } else {
        validate();
      }
    },
  },
};
</script>
